import React from 'react';

function Sidebar(props) {
  return (
    <svg
      height="24"
      style={{ fill: 'none' }}
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.5 3.2475H4.5C3.80964 3.2475 3.25 3.80714 3.25 4.4975V19.4975C3.25 20.1879 3.80964 20.7475 4.5 20.7475H19.5C20.1904 20.7475 20.75 20.1879 20.75 19.4975V4.4975C20.75 3.80714 20.1904 3.2475 19.5 3.2475Z"
        stroke="#292E36"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <path
        d="M15.75 3.2475V20.7475"
        stroke="#292E36"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
    </svg>
  );
}

export default Sidebar;
